import { Pipe, PipeTransform, inject } from '@angular/core';
import { MessageDto } from '@workspace/data-types';
import { UserStore } from '@workspace/ng-data-access';

@Pipe({
  name: 'canDeleteMessage',
  standalone: true,
})
export class CanDeleteMessagePipe implements PipeTransform {
  private readonly userStore = inject(UserStore);

  transform(msg: MessageDto, idx: number, messages: MessageDto[]): boolean {
    const userId = this.userStore.current()?._id;
    if (!userId || msg.sender.toString() !== userId.toString()) return false;

    // Sent less than 5 minutes ago
    const sentTime = new Date(msg.createdAt).getTime();
    const now = new Date().getTime();
    if (now - sentTime > 5 * 60 * 1000) return false;

    // No messages from other participants after this message
    for (let i = idx + 1; i < messages.length; i++) {
      if (messages[i].sender.toString() !== userId.toString()) {
        return false;
      }
    }

    return true;
  }
}
